import Init from "./init.view";

export default Init;
